import React from 'react';
import styled from 'styled-components';
import ClipLoader from 'react-spinners/ClipLoader';

const Loading = () => (
  <Wrapper>
    <ClipLoader color="#1e1e2d" size={50} />
  </Wrapper>
);

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: #f0f0f5;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 250px;
`;

export default Loading;
